import { loadThemePageContent } from '../pluginComponentApi';

export default async function (editor, opts = {}) {
  const bm = editor.BlockManager;
  const { pfx, refs, project, category } = opts;
  const { customHtmlCdns } = project;
  const ref = refs.themePageRef;
  console.log('ref theme-page', ref);
  let themePageSelectList = [];
  if (themePageSelectList) {
    customHtmlCdns &&
      customHtmlCdns.forEach((html) => {
        let preThemeObj = {};
        const fileNames = html.urlOrTag.split('/');
        let fileName = fileNames[fileNames.length - 1];
        preThemeObj['id'] = fileName;
        preThemeObj['url'] = html.urlOrTag;
        themePageSelectList.push(preThemeObj);
      });
  }
  themePageSelectList &&
    themePageSelectList.forEach(async (html) => {
      let mixedContent = await loadThemePageContent(html.url);
      bm.add(`themepage__${html.id}`, {
        label: `<i style="font-size: x-large;" class="webconnect webconnect-file-earmark-richtext"></i>
      <div class="gjs-block-label">${html.id}</div>`,
        category: 'Theme Page',
        select: true,
        content: `<div class='${pfx}' data-js=${ref} data-gjs-type=${ref}>
      ${mixedContent}
      </div>`,
        render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
      </div>
    `,
      });
    });
}
